import { StyledBox, lightColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledSectionTitle = styled.div`
  background: ${lightColors.button.error.hover};
  border-radius: ${({ theme }) => theme.radius.small} ${({ theme }) => theme.radius.small} 0 0;
  display: grid;
  height: 4rem;
  place-items: center;

  p {
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  }
`;

export const StyledMachineContent = styled(StyledBox)<{ $vmPanelOpen: boolean }>`
  align-items: center;
  border-radius: 0 0 ${({ theme }) => theme.radius.small} ${({ theme }) => theme.radius.small};
  display: grid;
  grid-template-columns: ${({ $vmPanelOpen }) => ($vmPanelOpen ? '1fr' : '1fr auto')};
  gap: 3rem;
  padding: 2.4rem 3rem;
  margin-bottom: 3rem;
  width: 100%;

  p {
    color: ${({ theme }) => theme.colors.text.main};
    text-align: center;
  }

  @media screen and (min-width: 1670px) {
    grid-template-columns: 1fr auto;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    gap: 3rem;
    grid-template-columns: 1fr;
  }
`;

export const StyledInfoValueWithCopyButton = styled.div`
  display: flex;
  align-items: center;

  p {
    margin-right: 0.5rem;
  }
`;

export const StyledInfoTitle = styled.p`
  margin-bottom: 1rem;
  line-height: 2rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
`;

export const StyledContent = styled.div<{ $vmPanelOpen: boolean }>`
  display: flex;
  gap: ${({ $vmPanelOpen }) => ($vmPanelOpen ? '1rem 2rem' : '1rem 8rem')};
  justify-content: ${({ $vmPanelOpen }) => ($vmPanelOpen ? 'space-between' : 'flex-start')};

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    justify-content: space-between;
    gap: 1rem 2rem;
  }

  @media screen and (min-width: 1670px) {
    justify-content: flex-start;
  }
`;

export const StyledButtonsWrapper = styled.div<{ $vmPanelOpen: boolean }>`
  display: flex;
  justify-content: ${({ $vmPanelOpen }) => ($vmPanelOpen ? 'flex-start' : 'flex-end')};
  gap: 1.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    justify-content: flex-start;
  }
`;
